var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index page-container"},[_c('page-contont-header',{staticClass:"page-contont-header",on:{"select":_vm.headerSelect}}),_c('div',{staticClass:"page-content"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }